import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanDeactivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CogsService } from './cogs.service';

@Injectable()
export class CogsGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private cogsService: CogsService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.cogsService.getCogs(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.cogsService.closeCogs();
        return true;
    }
}
